import { gql } from 'graphql-tag';

const PART_LIST_FRAGMENT = gql`
  fragment PartListFields on PartObject {
    id
    name
    number
    partIdentifier
    accountId
    warehouseId
    currentStock
    storageLocation
    isDiscontinued
    orderStatus
    isOrdered
    labels {
      id
      name
      color
    }
    warehouse {
      id
      name
    }
    createdAt
    updatedAt
  }
`;

export const GET_PARTS = gql`
  ${PART_LIST_FRAGMENT}
  query GetParts(
    $pagination: PaginationInput
    $filter: PartFilterInput
    $sort: PartSortInput
  ) {
    parts(pagination: $pagination, filter: $filter, sort: $sort) {
      data {
        ...PartListFields
      }
      meta {
        page
        limit
        total
        totalPages
        hasNext
        hasPrev
      }
    }
  }
`;

export const GET_PART = gql`
  query GetPart($id: ID!) {
    part(id: $id) {
      id
      name
      number
      partIdentifier
      description
      accountId
      warehouseId
      currentStock
      lotSize
      storageLocation
      isNotifyLowStock
      reorderPoint
      safetyStock
      isOrderByReorderPoint
      isNotReorder
      notReorderReason
      isDiscontinued
      replacementPartId
      orderStatus
      orderedQuantity
      orderDate
      expectedDelivery
      isOrdered
      labels {
        id
        name
        color
      }
      warehouse {
        id
        name
        street
        zip
        city
        country
        isDefault
      }
      contacts {
        id
        firstName
        lastName
        email
        phone
        company
      }
      suppliers {
        supplier {
          id
          name
          street
          zip
          city
          country
        }
        manufacturerPartNumber
        unitPrice
        isDefault
      }
      createdAt
      updatedAt
    }
  }
`;

export const GET_STOCK_HISTORY_BY_PART = gql`
  query GetStockHistoryByPart($partId: ID!) {
    stockHistoryByPart(partId: $partId) {
      id
      partId
      date
      userName
      type
      quantity
      stockBefore
      stockAfter
      details
      createdBy
      createdAt
    }
  }
`;

export const BOOK_MATERIAL = gql`
  mutation BookMaterial($input: BookMaterialInput!) {
    bookMaterial(input: $input) {
      id
      partId
      date
      userName
      type
      quantity
      stockBefore
      stockAfter
      details
      createdBy
      createdAt
    }
  }
`;

export const MARK_PART_ORDERED = gql`
  mutation MarkPartOrdered($input: MarkPartOrderedInput!) {
    markPartOrdered(input: $input) {
      id
      name
      number
      partIdentifier
      description
      accountId
      warehouseId
      currentStock
      lotSize
      storageLocation
      isNotifyLowStock
      reorderPoint
      safetyStock
      isOrderByReorderPoint
      isNotReorder
      notReorderReason
      isDiscontinued
      replacementPartId
      orderStatus
      orderedQuantity
      orderDate
      expectedDelivery
      isOrdered
      createdAt
      updatedAt
    }
  }
`;

export const MARK_PART_DISCONTINUED = gql`
  mutation MarkPartDiscontinued($input: MarkPartDiscontinuedInput!) {
    markPartDiscontinued(input: $input) {
      id
      name
      isDiscontinued
      replacementPartId
      orderStatus
      orderedQuantity
      orderDate
      expectedDelivery
      isOrdered
      currentStock
      createdAt
      updatedAt
    }
  }
`;
